import { ReplicatorStatus } from "../../models/ReplicatorStatus";
import { SET_SYNC_STATUS, SET_ARCGIS_TOKEN, CLEAR_ARCGIS_TOKEN, AppControlActionTypes, AppControlState } from "./types";

const initialState: AppControlState = {
    loading: false,
    currentSyncStatus: {} as ReplicatorStatus,
    arcgisToken: undefined,
};

const reducer = (state = initialState, action: AppControlActionTypes) => {
    switch (action.type) {
        case SET_SYNC_STATUS:
            return {
                ...state,
                currentSyncStatus: action.newStatus,
            };
        case SET_ARCGIS_TOKEN:
            return {
                ...state,
                arcgisToken: action.token,
            };
        case CLEAR_ARCGIS_TOKEN:
            return {
                ...state,
                arcgisToken: undefined,
            };
        default:
            return state;
    }
};

export default reducer;
